module.exports = __webpack_public_path__ + "img/box-2-eng.f43b05a6.png";